import { useDictionary } from '../../../../../../utilities/hooks/UseDictionary';
import { UseCurrencyDecorator } from '../../../../../../utilities/hooks/UseCurrencyDecorator';
import { useProviderCurrency } from '../../../../../../utilities/hooks/useProviderCurrency';
import SlotPricingItem from './SlotPricingItem';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { AmountFormatHelper } from '../../../../../../utilities/helpers/AmountFormatHelper';

const SlotPricing = ({ details }) => {
	const dictionary = useDictionary();
	const currencyDecorator = UseCurrencyDecorator();
	const providerCurrency = useProviderCurrency();
	const currency = details?.experience?.currency ?? providerCurrency;

	const [groups, setGroups] = useState(null);

	const getGroups = () => {
		let groups = {};
		details?.experience?.participant_groups?.map((group) => {
			groups[group?.name] = currencyDecorator(
				AmountFormatHelper.formatAmount(group?.rate),
				currency
			);
		});

		setGroups(groups);
	};

	useEffect(() => {
		getGroups();
	}, []);

	return (
		<div className="settings-page-container thin-scrollbar fade-on-load">
			<>
				<div
					className="participant-row-container"
					style={{ justifyContent: 'space-between', marginBottom: '20px' }}
					data-testid="pricing-header"
				>
					<h3 style={{fontWeight: 500,fontSize: 16}}>{dictionary.participants_pricing}</h3>
				</div>

				{groups
					? Object?.keys(groups)?.map((key) => (
							<SlotPricingItem key={key} title={key} value={groups[key]} />
					  ))
					: null}

				{details?.experience?.group_rates?.length > 0 && (
					<>
						<div
							className="participant-row-container"
							style={{
								justifyContent: 'space-between',
								marginTop: '8px',
								marginBottom: '20px'
							}}
							data-testid="pricing-header"
						>
							<h3>{dictionary.group_rates}</h3>
						</div>
						{details?.experience?.group_rates?.map(({ min_size, max_size, discount }, index) => (
							<SlotPricingItem
								key={index}
								title={`${dictionary.group_size} ${min_size}-${max_size}`}
								value={`-${discount}%`}
							/>
						))}
					</>
				)}
			</>
		</div>
	);
};

SlotPricing.propTypes = {
	details: PropTypes.object
};

export default SlotPricing;
